import * as actionType from "./actionTypes";
import { parseQueryString } from "../../util";
import * as toastrAction from "./toasters";
import config from "../../Api";
import { actions, toastr } from "react-redux-toastr";
import { default as apiEndPoints } from "../../Routes/FreeTestList/utils/apiEndPoints";
import axios from "axios";
import { debounce } from "../../util";
import i18n from "../../i18n";
const QUERY = parseQueryString(window.location.search);
const WL_TOKEN = QUERY.token;
let CMS_TOKEN =
  "eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YzBmY2I1OGExMGVlNjI5NjgxYWU4NjYiLCJuYW1lIjoiQ0xQIE1hc3RlciIsImVtYWlsIjoiZW5naW5lZXJpbmdAY2xhc3NwbHVzLmNvIiwiY29udGFjdCI6eyJjb3VudHJ5Q29kZSI6OTEsIm1vYmlsZSI6ODA3Njc2NzMxNX0sIm9yZ2FuaXphdGlvbiI6eyJpZCI6MSwiY29kZSI6ImNscCJ9LCJyb2xlIjpbImFkbWluIl0sImFsbG93U2hhcmluZyI6ZmFsc2UsImFsbG93R3BzY1R5cGUiOmZhbHNlLCJpYXQiOjE2MjYxNzI4MzcsImV4cCI6MTYyNzkwMDgzN30.mq8tHOyMdDjrtoI0pYTpJGnX7ALYDc6o2BYRVwpVo4jAdnMxKsUMcYaMDpDXF3-9";
let STUDENT_SIDE =
  "eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjE3OTc5NzU3LCJuYW1lIjoiQW5raXQgQ2hhd2xhIiwiZW1haWwiOiJhbmtpdC5jaGF3bGFAY2xhc3NwbHVzLmNvIiwibW9iaWxlIjoiOTE5OTkyMzExNTk2Iiwic3R1ZGVudElkIjoxNDQ3OTYxMiwidGltZXN0YW1wIjoxNjI1NzQ3NTc4MDkxLCJvcmdJZCI6MSwic2hhcmVkVGVzdElkIjoiNjBlZDM3NmRmNTlmNmM2MWFhNDk3YTQ1IiwibnVtYmVyT2ZBdHRlbXB0cyI6LTEsInRlc3RJZCI6IjVlMTQyYWU3NmY4MTg0NWM5NzE0ZGQzNyIsImJ1aWxkVHlwZSI6MSwiaWF0IjoxNjI2MTgyMzgzLCJleHAiOjE2Mjc5MTAzODMsInR5cGUiOjN9.9ZzaiZG_CamNPvkNcqW_J2kLVhxKlJqjB4XYPKXvKfHLufDndaUTl4VuJwUSSGqo";
let timeOut = null;
export const setFreeTestState = (data) => {
  return {
    type: actionType.SET_FREE_TEST_STATE,
    payload: {
      data: data,
    },
  };
};

export const getTestList = (payload) => (dispatch, getState) => {
  let state = getState();

  let tutorToken = parseQueryString(window.location.search);
  tutorToken = tutorToken.token;
  dispatch({
    type: actionType.SET_FREE_TEST_LOADING,
    payload: true,
  });
  axios
    .get(
      `${config.API_URL_TUTOR}${apiEndPoints.FreeTest.GET_TESTLIST.url(
        payload
      )}`,
      {
        headers: {
          "x-access-token": state.loginReducer.tutorSideToken || tutorToken,
        },
      }
    )
    .then((response) => {
      dispatch({
        type: actionType.SET_TESTLIST,
        payload: {
          ...response.data.data,
          offset: payload.offset,
          search: payload.search,
        },
      });
      if (!state.loginReducer.tutorSideToken) {
        dispatch({
          type: actionType.SET_TUTOR_SIDE_TOKEN,
          payload: {
            tutorSideToken: tutorToken,
          },
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionType.SET_FREE_TEST_LOADING,
        payload: false,
      });
      console.log("errr", err);
      toastr.error("ERROR", err.response.data.message);
    });
};

export const getFreeTestList = (payload) => (dispatch, getState) => {
  let state = getState();
  dispatch({
    type: actionType.SET_FREE_TEST_LOADING,
    payload: true,
  });
  axios
    .get(
      `${config.API_URL_TUTOR}${apiEndPoints.FreeTest.GET_FREE_TESTLIST.url(
        payload
      )}`,
      { headers: { "x-access-token": state.loginReducer.tutorSideToken } }
    )
    .then((response) => {
      if (!payload.search && response.data.data.count == 0) {
        //window.location.href="/noFreeTestAdded?token="+state.loginReducer.tutorSideToken
        dispatch({
          type: actionType.SET_FREE_TEST_STATE,
          payload: {
            data: "SetNoFreeTest",
          },
        });
      } else {
        dispatch({
          type: actionType.SET_FREE_TESTLIST,
          payload: {
            ...response.data.data,
            offset: payload.offset,
            search: payload.search,
          },
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionType.SET_FREE_TEST_LOADING,
        payload: false,
      });
      console.log("errr", err);
      toastr.error("ERROR", err.response.data.message);
    });
};

export const getTestDetails =
  (testId, testName, bottomDrawer) => (dispatch, getState) => {
    let state = getState();
    let tutorToken = parseQueryString(window.location.search).token;
    dispatch({
      type: actionType.SET_FREE_TEST_LOADING,
      payload: true,
    });
    axios
      .get(
        `${config.API_URL_TUTOR}${apiEndPoints.FreeTest.GET_TEST_DETAILS.url(
          testId
        )}`,
        {
          headers: {
            "x-access-token": state.loginReducer.tutorSideToken || tutorToken,
          },
        }
      )
      .then((response) => {
        dispatch({
          type: actionType.SET_TEST_DETAILS,
          payload: {
            data: response.data.data,
            bottomDrawer: bottomDrawer,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: actionType.SET_TEST_DETAILS,
          payload: {
            data: {
              _id: testId,
              testName: testName,
              isNew: true,
              testType: err?.response?.data?.data?.testType || false,
            },
          },
        });
        dispatch({
          type: actionType.SET_FREE_TEST_LOADING,
          payload: false,
        });
      });
  };

export const CreateSharedTest = (data) => (dispatch, getState) => {
  let state = getState();
  let testId = state.freeTestReducer.testDetails._id;
  let payload = { ...data, testId: testId };
  let tutorToken = parseQueryString(window.location.search).token;
  axios
    .post(
      `${config.API_URL_TUTOR}${apiEndPoints.FreeTest.CREATE_SHARE_TEST.url()}`,
      payload,
      {
        headers: {
          "x-access-token": state.loginReducer.tutorSideToken || tutorToken,
        },
      }
    )
    .then((response) => {
      // if(data && data.hasOwnProperty("isFree") && data.isFree==true)
      //      toastr.success("SUCCESS","Added to free tests");
      // if(data && data.hasOwnProperty("isFree") && data.isFree==false)
      //      toastr.success("SUCCESS","Removed from free tests");
      // if(data && data.hasOwnProperty("startTime") && data.startTime )
      //      toastr.success("SUCCESS","Duration set Sucessfully");
      toastr.success(
        i18n.t("store.actions.freeTestAction.success", "SUCCESS"),
        response.data.message
      );
      dispatch({
        type: actionType.SET_TEST_DETAILS,
        payload: {
          data: response.data.data,
        },
      });
      dispatch({
        type: actionType.SET_WHATSAPP_DRAWER,
        flag: true,
      });
    })
    .catch((err) => {
      toastr.error("Error", err.response.data.message);
    });
};
export const UpdateFreeTest = (data, sharedID) => (dispatch, getState) => {
  let state = getState();
  let tutorToken = parseQueryString(window.location.search).token;
  if (state.freeTestReducer.testDetails.isNew) {
    clearTimeout(timeOut);
    timeOut = setTimeout(() => {
      dispatch(CreateSharedTest(data));
    }, 1000);
  } else {
    let shareTestId = sharedID || state.freeTestReducer.testDetails._id;
    axios
      .patch(
        `${config.API_URL_TUTOR}${apiEndPoints.FreeTest.UPDATE_SHARE_TEST.url(
          shareTestId
        )}`,
        data,
        {
          headers: {
            "x-access-token": state.loginReducer.tutorSideToken || tutorToken,
          },
        }
      )
      .then((response) => {
        if (!data.isRemoved) {
          //toastr.success("SUCCESS",response.data.message);
          dispatch({
            type: actionType.SET_TEST_DETAILS,
            payload: {
              data: response.data.data,
            },
          });
          if (data.hasOwnProperty("isRemoved") && data.isRemoved == false) {
            toastr.success(
              i18n.t("store.actions.freeTestAction.success", "SUCCESS"),
              response.data.message
            );
            dispatch({
              type: actionType.SET_WHATSAPP_DRAWER,
              flag: true,
            });
          } else {
            toastr.success(
              i18n.t("store.actions.freeTestAction.success", "SUCCESS"),
              i18n.t(
                "store.actions.freeTestAction.freeTestEdit",
                "Free Test edited successfully"
              )
            );
            setTimeout(() => {
              window.history.go(-2);
            }, 3000);
          }
        } else {
          dispatch(
            toastrAction.addTimedToaster({
              text: i18n.t(
                "store.actions.freeTestAction.testRemoved",
                "Test removed from free tests successfully!"
              ),
            })
          );
          setTimeout(() => {
            window.location.href = window.location.href;
          }, 3000);
        }
      })
      .catch((err) => {
        toastr.error("Error", err.response.data.message);
      });
  }
};

export const changeValue = (changeObj) => {
  return {
    type: actionType.SET_DATE,
    changeObj,
  };
};

export const fetchTestStats = (payload) => (dispatch, getState) => {
  let state = getState();
  axios({
    method: "POST",
    url: `${config.API_URL_STUDENT}/stats/test`,
    data: {
      sharedTestId: payload.sharedTestId,
      // sharedTestId: "60ed376df59f6c61aa497a45",
      limit: payload.limit,
      offset: payload.offset,
    },
    headers: {
      "x-cms-access-token": state.loginReducer.studentSideToken
        ? state.loginReducer.studentSideToken
        : payload.token,
    },
  })
    .then((response) => {
      // if(response.data.data.records)
      dispatch({
        type: actionType.SET_TEST_STUDENT_DETAILS,
        payload: {
          ...response.data.data,
          offset: payload.offset,
          search: payload.search,
        },
      });
    })
    .catch((err) => {
      toastr.error("ERROR", err.response.data.message);
    });
};

export const fetchLeaderBoard = (payload) => (dispatch, getState) => {
  let state = getState();
  axios({
    method: "POST",
    url: `${config.API_URL_STUDENT}/stats/leaderboard`,
    data: {
      sharedTestId: payload.sharedTestId,
    },
    headers: {
      "x-cms-access-token": state.loginReducer.studentSideToken
        ? state.loginReducer.studentSideToken
        : payload.token,
    },
  })
    .then((response) => {
      dispatch({
        type: actionType.SET_LEADER_BOARD_DETAILS,
        payload: response.data.data,
      });
    })
    .catch((err) => {
      toastr.error("ERROR", err.response.data.message);
    });
};

export const resetData = (payload) => {
  return {
    type: actionType.RESET_TEST_STUDENT_DETAILS,
    payload,
  };
};

export const setDrawer = (flag) => {
  return {
    type: actionType.SET_BOTTOM_DRAWER,
    flag,
  };
};
export const whatsAppDrawer = (flag) => {
  return {
    type: actionType.SET_WHATSAPP_DRAWER,
    flag,
  };
};
